import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'rmsJoin',
    standalone: false
})
export class RmsJoinPipe implements PipeTransform {
  transform(input: Array<any>, sep = ', ', field?: string): string {
    if (field && input[0] && field in input[0]) {
      return input.map(i => i && i[field]).join(sep);
    }
    return input.join(sep);
  }

}
